import * as Sentry from "@sentry/browser";

if (window.SENTRY_CONFIG && window.SENTRY_CONFIG.dsn) {
    Sentry.init({
        dsn: window.SENTRY_CONFIG.dsn,
        environment: window.SENTRY_CONFIG.environment,
        release: window.SENTRY_CONFIG.release,
        sendDefaultPii: true,
        tracesSampleRate: 0.1,
        integrations: [Sentry.browserTracingIntegration()],
    });

    if (window.SENTRY_CONFIG.user) {
        Sentry.setUser(window.SENTRY_CONFIG.user);
    }
}
